import { MatPaginatorIntl } from "@angular/material/paginator";

export class PaginatorHungarianIntl extends MatPaginatorIntl {
  constructor() {
    super();
    this.nextPageLabel = 'Következő oldal';
    this.previousPageLabel = 'Előző oldal';
    this.firstPageLabel = 'Első oldal';
    this.lastPageLabel = 'Utolsó oldal';
    this.itemsPerPageLabel = 'Oldal elemeinek száma';
    this.getRangeLabel = (page, pageSize, length) => {
      //  From: https://stackoverflow.com/a/46883528
      if (length === 0 || pageSize === 0) {
        return '0 / ' + length;
      }
      length = Math.max(length, 0);
      const startIndex = page * pageSize;
      const endIndex = startIndex < length ?
        Math.min(startIndex + pageSize, length) :
        startIndex + pageSize;
      return startIndex + 1 + ' - ' + endIndex + ' / ' + length;
    }
  }
}
